module.exports = __webpack_public_path__ + "static/media/  (91).df0b3d8d.jpg";